import moment from 'moment';
import React from 'react';
import { Table } from 'reactstrap';
import TableInvoiceRow from './TableRow';

// {
//   "hdon_id": "b1654d9c-75cb-4a17-9daf-95c44817902a",
//   "cctbao_id": "ac683498-03fe-4c3f-a6c0-4f1074a62956",
//   "hdlket_id": null,
//   "tthai": "CQT đã nhận",
//   "tthdon": 0,
//   "khieu": "1K22TCN",
//   "shdon": "1414256",
//   "tdlap": "2022-12-26T15:23:12.454071",
//   "dvtte": "VND",
//   "tgia": 1,
//   "gchu": null,
//   "tnmua": "",
//   "mnmua": "10001497",
//   "ten": "Tran Minh Phuong",
//   "mst": "1200100814",
//   "dchi": "ap Tan Ninh,Tan Phu,TPD",
//   "email": "",
//   "sdtnmua": "",
//   "stknmua": "",
//   "htttoan": "Tiền mặt/Chuyển khoản",
//   "stknban": "",
//   "sbmat": "3088c98",
//   "mdvi": "VP",
//   "nglap": "1200100814",
//   "nlap": "2022-12-26T00:00:00",
//   "ngsua": null,
//   "nsua": null,
//   "tgtcthue": 303048,
//   "tgtthue": 15152,
//   "ttcktmai": 0,
//   "tgtttbso": 318200,
//   "tgtttbchu": "Ba trăm mười tám nghìn hai trăm đồng chẵn",
//   "dlqrcode": null,
//   "sdhang": "",
//   "shdon1": null,
//   "mccqthue": null,
//   "ngky": "1200100814",
//   "nky": "2022-12-26T15:24:10.760272",
//   "signature": null,
//   "hthdbtthe": null,
//   "tdlhdbtthe": null,
//   "khmshdbtthe": null,
//   "khhdbtthe": null,
//   "shdbtthe": null,
//   "tgtphi": 0,
//   "tgtcthue0": 0,
//   "tgtthue0": 0,
//   "ttcktmai0": 0,
//   "tgtttbso0": 0,
//   "tgtcthue5": 303048,
//   "tgtthue5": 15152,
//   "ttcktmai5": 0,
//   "tgtttbso5": 0,
//   "tgtcthue10": 0,
//   "tgtthue10": 0,
//   "ttcktmai10": 0,
//   "tgtttbso10": 318200,
//   "tgtcthuekct": 0,
//   "tgtthuekct": 0,
//   "ttcktmaikct": 0,
//   "tgtttbsokct": 0,
//   "tgtcthuekkk": 0,
//   "tgtthuekkk": 0,
//   "ttcktmaikkk": 0,
//   "tgtttbsokkk": 0,
//   "tgtphi0": null,
//   "tgtphi5": null,
//   "tgtphi10": null,
//   "tgtphikct": null,
//   "tgtphikkk": null,
//   "lhdon": null,
//   "lddnbo": null,
//   "tnvchuyen": null,
//   "ptvchuyen": null,
//   "dckhoxuat": null,
//   "dckhonhap": null,
//   "tennguoinhanhang": null,
//   "mstnguoinhanhang": null,
//   "phongban": null,
//   "veviec": null,
//   "sohopdong": null,
//   "hdon68_id_lk": null,
//   "mtdiep_cqt": "0100686209FF2E1E5916934C2BBAEA68336241A0E6",
//   "mtdiep_gui": "1200100814EF5E280918CF4A3EA71E6015C4EC6B0F",
//   "tthdon_old": null,
//   "hdon_id_old": null,
//   "is_hdcma": 0,
//   "hdon_ghichu": null,
//   "tthdon_original": 0,
//   "kygui_cqt": 1,
//   "hdktngay": null,
//   "tnhban": "",
//   "tnhmua": "",
//   "hddckptquan": null,
//   "sbke": null,
//   "faxban": null,
//   "webban": null,
//   "sqdbants": null,
//   "nqdbants": null,
//   "cqqdbants": null,
//   "htbants": null,
//   "cmndmua": null,
//   "hdvc": null,
//   "hvtnxhang": null,
//   "hdktso": null,
//   "nbke": null,
//   "ddvchden": null,
//   "tgvchdtu": null,
//   "tgvchdden": null,
//   "sdtban": null,
//   "tkcktmn": 0,
//   "tgtttbso_last": 318200,
//   "mdvqhnsach_mua": null,
//   "mdvqhnsach_ban": null,
//   "stbao": null,
//   "ntbao": null,
//   "kmai": null,
//   "tgtcthuek": 0,
//   "tgtthuek": 0,
//   "ttcktmaik": 0,
//   "tgtttbsok": 0,
//   "error_status": "0",
//   "issendmail": false,
//   "docngoaitetv": true,
//   "giamthuebanhang20": null,
//   "tienthuegtgtgiam": null,
//   "lhdclquan": null,
//   "khmshdclquan": null,
//   "khhdclquan": null,
//   "shdclquan": null,
//   "nlhdclquan": null,
//   "tiletienthuegtgtgiam": null,
//   "tgtkhac": null,
//   "thdon": null,
//   "qtich": null,
//   "cnctru": null,
//   "ngccmnd": null,
//   "nccmnd": null,
//   "ktnhap": null,
//   "thang": null,
//   "nam": null,
//   "msbl_tncn": null,
//   "tlkthu": null,
//   "loaihd": 1,
//   "cmnd": null,
//   "dvtinh": null,
//   "hdtndinh": null,
//   "hdckhau": null,
//   "kdbhbbuoc": null,
//   "ktnhapstr": null,
//   "cnkctru": null,
//   "tudongtinhtien": null,
//   "tgtkcthue": null
// }
function TableInvoice({ invoiceList }) {
  return (
    <Table bordered responsive>
      <thead
        style={{
          background: '#006926',
          color: 'white',
          fontWeight: 'bold',
          textAlign: 'center',
        }}>
        <tr>
          <td>Mẫu</td>
          <td>Ký hiệu</td>
          <td>Trạng thái hoá đơn</td>
          <td>Trạng thái thanh toán</td>
          <td>Số hoá đơn</td>
          <td>Ngày hoá đơn</td>
          <td>Tổng tiền</td>
          <td>Giấy báo</td>
          <td>Hoá đơn</td>
        </tr>
      </thead>
      <tbody>
        {invoiceList.map((item, index) => {
          return (
            <TableInvoiceRow
              key={index}
              hoaDonInfo={{
                mau_hoa_don: '1',
                ky_hieu: item.khieu,
                so_hoa_don: item.shdon,
                trang_thai_hoa_don: item.tthai,
                trang_thai_thanh_toan: item.trang_thai_thanh_toan,
                ngay_hoa_don: moment(item.tdlap)
                  .format('DD/MM/YYYY')
                  .toString(),
                tong_tien: Number(item.tgtttbso_last).toLocaleString(),
                ma_bao_mat: item.sbmat,
              }}
            />
          );
        })}
      </tbody>
    </Table>
  );
}

export default TableInvoice;
